import { isAuthenticatedCustomer, useToken } from '@ori/auth';
import { getHeaders, useGraphqlQuery } from '@ori/fetching';
import { useEffect, useState } from 'react';

import { APP_NAME } from '../constants';
import { useConfiguration } from '../contexts';
import type { GetCustomerQuery, GetCustomerQueryVariables } from '../models';
import { customerQuery } from '../queries';
import { sendCustomerData } from '../utils';

export interface UseSendCustomerAttributesParams {
  clientLoaded?: boolean;
}

export const useSendCustomerAttributes = ({ clientLoaded }: UseSendCustomerAttributesParams) => {
  const { currentLanguage, customerId, graphqlUrl, tenant } = useConfiguration();
  const isAuthenticated = isAuthenticatedCustomer(customerId);
  const { token } = useToken();
  const [attributesSent, setAttributesSent] = useState(false);
  const { data, error } = useGraphqlQuery<GetCustomerQuery, GetCustomerQueryVariables>({
    query: customerQuery,
    url: graphqlUrl,
    headers: getHeaders({
      customerId,
      language: currentLanguage,
      sourceAppName: APP_NAME,
      tenant,
      token,
    }),
    skip: !isAuthenticated || !clientLoaded,
  });

  if (error) {
    // eslint-disable-next-line no-console -- Need to log error to console
    console.error(error);
  }

  useEffect(() => {
    if (clientLoaded && (data != null || error || !isAuthenticated)) {
      sendCustomerData({ currentLanguage, data, tenant });
      setAttributesSent(true);
    }
  }, [clientLoaded, currentLanguage, data, error, isAuthenticated, tenant]);

  return {
    attributesSent,
  };
};
